module.exports = __webpack_public_path__ + "img/weather60.3d284789.png";